var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
export var PercentageBox = function (_a) {
    var percentageTitle = _a.percentageTitle, comparisonPercentage = _a.comparisonPercentage, _b = _a.isPositive, isPositive = _b === void 0 ? true : _b;
    var theme = useTheme();
    var isComparisonPercentage = comparisonPercentage || comparisonPercentage === 0;
    var roundedComparisonPercentage = isComparisonPercentage
        ? Math.round(comparisonPercentage)
        : "-,-";
    return (_jsxs(Box, __assign({ sx: {
            borderLeft: "2px solid ".concat(isPositive ? theme.palette.success.main : theme.palette.error.main),
            pl: 2,
            mb: 3,
        } }, { children: [_jsx(Box, { children: _jsxs(Typography, __assign({ variant: "h4" }, { children: [isComparisonPercentage ? "~ " : "", " ", roundedComparisonPercentage, "%"] })) }), percentageTitle && (_jsx(Box, { children: _jsx(Typography, __assign({ variant: "body2", color: "text.primary" }, { children: percentageTitle })) }))] })));
};
